module.exports = __webpack_public_path__ + "static/img/product_images_17_h5_zh.79c6c89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_17_h5_zh.png
// module id = N0eT
// module chunks = 34